export const CallAPI = {
    login: 'v1/api/ipbx/login',
    dial: 'v1/api/ipbx/outboundcall',
    dialMob: 'v1/api/ipbx/outboundcallmobile',
    dialLandline: 'v1/api/ipbx/outboundlandline',
    dialIInterv: 'v1/api/ipbx/outboundinternational',
    refresh: 'v1/api/ipbx/refreshoutboundcall',
    logout: 'v1/api/ipbx/logout?token=',
    recording: 'v1/api/callrecordings?applicationId=',
    callLogs: 'v1/api/retellAi?',
}